import type { AnimalMediaItem } from '@/types/api';

/** URL leve para grade (miniatura quando existir). */
export function mediaGridPreviewUrl(media: AnimalMediaItem['media']): string {
  return media.thumbnail_url ?? media.url;
}

export interface AnimalMediaPageMeta {
  page: number;
  per_page: number;
  total: number;
  has_more: boolean;
}

export interface AnimalMediaPageResponse {
  media: AnimalMediaItem[];
  meta?: AnimalMediaPageMeta;
}
